import React from "react";
import classnames from "classnames";

import { DealDiscountType } from "custom-types/Deals";

const DiscountTag = ({
  discountLabel,
  className,
  side = "left",
  isRounded = false,
}: {
  discountLabel: string;
  discountType?: DealDiscountType;
  className: string;
  side?: string;
  isRounded: boolean;
}) => {
  const onLeft = side === "left" || !side;

  return (
    <>
      <div className={`absolute flex ${className}`}>
        {!onLeft && (
          <div className="discount-tag--triangle-right inline-block border-notification" />
        )}
        <div
          className={classnames(
            "discount-tag bg-notification text-white text-xs p-xs inline-block font-bold",
            {
              "rounded-tl": isRounded && onLeft,
              "rounded-tr": isRounded && !onLeft,
            },
          )}
        >
          {discountLabel}
        </div>
        {onLeft && (
          <div className="discount-tag--triangle-left inline-block border-notification" />
        )}
      </div>
      <style jsx>{`
        .discount-tag {
          line-height: var(--font-size-xs);
        }

        .discount-tag--triangle-left {
          width: 0;
          height: 0;
          border-top-width: calc(var(--font-size-xs) + 8px);
          border-right: calc(var(--font-size-xs) + 8px) solid transparent;
        }

        .discount-tag--triangle-right {
          width: 0;
          height: 0;
          border-top-width: calc(var(--font-size-xs) + 8px);
          border-left: calc(var(--font-size-xs) + 8px) solid transparent;
        }
      `}</style>
    </>
  );
};

export default DiscountTag;
